/**
 * SSO 单点登录配置和工具函数
 */

// SSO 配置
const SSO_CONFIG = {
  // SSO 服务器地址
  server: 'https://sso.imile-inc.com',
  // OAuth 客户端 ID
  clientId: 'e8f7e762ad8e6f186d3a',
  // 回调地址路径
  callbackPath: '/#/callback',
  // OAuth 参数
  responseType: 'code',
  scope: 'read',
  state: 'casdoor',
} as const;

/**
 * 构建 SSO 登录 URL
 * @returns SSO 登录 URL
 */
export function buildSSOLoginUrl(): string {
  // 使用当前页面的 origin 作为基础 URL，确保回调地址与当前环境一致
  const currentOrigin = window.location.origin;
  const redirectUri = encodeURIComponent(`${currentOrigin}${SSO_CONFIG.callbackPath}`);
  return `${SSO_CONFIG.server}/login/oauth/authorize?client_id=${SSO_CONFIG.clientId}&response_type=${SSO_CONFIG.responseType}&redirect_uri=${redirectUri}&scope=${SSO_CONFIG.scope}&state=${SSO_CONFIG.state}`;
}

/**
 * 跳转到 SSO 登录页面
 */
export function redirectToSSO(): void {
  window.location.href = buildSSOLoginUrl();
}

